import React from "react";
import { Link } from "react-router-dom";
import AppointmentSection from "./AppointmentSection";
import { isBlogEditor, getStoredUser } from "../../../utils/authClient";
import "./Dashboard.css";

function Dashboard() {
  const showBlog = isBlogEditor();
  const u = getStoredUser();

  return (
    <>
      {showBlog ? (
        <div className="dashboard_editor_banner">
          <p className="dashboard_editor_banner_text">
            Cuenta editorial: {u && u.email ? u.email : ""} ({u && u.role})
          </p>
          <Link
            to="/admin/blog"
            className="dashboard_editor_banner_link"
          >
            Crear artículo del blog
          </Link>
        </div>
      ) : null}
      <div className="dashboard_main page-shell">
        <AppointmentSection />
      </div>
    </>
  );
}

export default Dashboard;
